import Dexie from 'dexie';
import { TaskData } from '../models';
import { AppState } from '../../core/app-state';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DexieService extends Dexie {
    //Define Tables
    taskData: Dexie.Table<TaskData, number>;
    cache: Dexie.Table<CacheData, number>

  constructor(
    private appState: AppState
  ) {
    super('local-db');

    //define tables that db will store
    this.version(1).stores({
      taskData: '++id, task_id, uploaded', //identify auto-incremented primary key followed by indexed values(only specify values you wish to index and don't index images/large values)
      cache: '++id, url, lastUpdated'
    });

    this.taskData.mapToClass(TaskData);
  }

  async clearAll() {
    try {
        await Promise.all([this.taskData.clear()]);
    } catch (ex) {
        console.error(ex);
    }
  }

  async deleteDB() {
    this.delete()
  }

  async create(table: Dexie.Table, item: any): Promise<any> {
    return await table.add(item);
  }

  async setUploadStatus(table: Dexie.Table, primaryKey: any, status: number) {
    table.update(primaryKey, {uploaded: status})
  }

  updatePendingUploadCount() {
    this.taskData.where('uploaded').equals(0).count(count => {
      this.appState.setPendingUploadCount(count)
    })
  }
}


//Define interface for table records
export interface CacheData {
  url: string,
  lastUpdated: Date,
  httpResp: string
}